import { CentraProduct, MediaKeys } from "../atomicSetup";

export type FormattedMedia = {
  type: "image";
  href: string;
  alt: string;
  isEnvironmental: boolean;
  isPackshot?: boolean;
};

export const getMediaObjects = (product: CentraProduct, size: MediaKeys) => {
  const mediaList: FormattedMedia[] = [];
  for (const media of product?.mediaObjects ?? []) {
    const source = media.sources[size]?.at(0);
    if (!source) {
      continue;
    }

    const attributes = Array.isArray(media.attributes)
      ? {}
      : (media.attributes ?? {});

    const mediaObject = {
      type: "image",
      href: source.url,
      alt: "", // TODO - need alt attribute from Centra
      isEnvironmental: attributes.img_config_environmental === "1",
      isPackshot: attributes.img_config_isPackshot === "1",
    } satisfies FormattedMedia;

    mediaList.push(mediaObject);
  }

  return mediaList;
};
